module.exports = __webpack_public_path__ + "c00563d30f25f9b4969162998b057d30.mp4";